import {Button, Tooltip, message} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import React, {useState, useEffect} from "react";
import api from "../api";
import {useBulkJobsState} from "../../contexts/BulkJobsContext";
import {useTranslation} from "react-i18next";

export default ({uploadId}) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [guid, setGuid] = useState();

    const {dataDownloads} = useBulkJobsState();
    const data = dataDownloads[guid];

    useEffect(() => {
        if (data?.url) {
            downloadFile(`/api/downloads/table_data?key=${data.key}`);
            setLoading(false);
            setGuid();
        }
    }, [data?.url]);

    const onClick = () => {
        setLoading(true);
        message.info(t('message-preparing-report', 'Preparing upload report...'));

        api.get(`/api/uploads/${uploadId}/report`).then(res => {
            setGuid(res.data.guid);
        }).catch(err => {
            setLoading(false);
            message.error(t('message-report-error', 'Failed to generate report'));
        });
    };

    return (
        <Tooltip title={t('download-report', 'Download Report')}>
            <Button
                icon={<DownloadOutlined/>}
                onClick={onClick}
                loading={loading}
            />
        </Tooltip>
    );
};

function downloadFile(filePath) {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = filePath;
    link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
    link.click();
}
